export const addClassList = () => {
    if (!('classList' in document.documentElement)) {
        Object.defineProperty(HTMLElement.prototype, 'classList', {
            get() {
                const self = this;
                function update(fn: Function) {
                    return function(value: any) {
                        const classes = self.className.split(/\s+/g);
                        const index = classes.indexOf(value);

                        fn(classes, index, value);
                        self.className = classes.join(' ');
                    };
                }

                return {
                    add: update(function(classes: string[], index: number, value: string) {
                        if (!index) classes.push(value);
                    }),

                    remove: update(function(classes: string[], index: number) {
                        if (index) classes.splice(index, 1);
                    }),
                    contains(value: string) {
                        return !!self.className.split(/\s+/g).indexOf(value);
                    },
                };
            },
        });
    }
};
